<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col md="5">
         <side-effect-form @emitData="create"/>
        </v-col>
        <v-col md="7">
          <v-card class="card--shadow">
           <side-effect-list :sideEffects="sideEffects"/>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import SideEffectForm from '@/components/side-effect/SideEffectForm';
import SideEffectList from '@/components/side-effect/SideEffectList';
import { mapState } from "vuex";

export default {
  components: {
    SideEffectForm,
    SideEffectList,
  },
  computed: {
    ...mapState("SideEffect", ["sideEffects"]),
  },
  methods: {
    create(data) {
      this.$store.dispatch("SideEffect/create", data);
    },
  },
  created() {
    this.$store.dispatch("SideEffect/get");
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
